import { LOCALES } from "../constants.js";
const replaceUnderscoresWithHyphens = (input) => {
  return input.replace(/_/g, "-");
};
const replaceHyphensWithUnderscores = (input) => {
  return input.replace(/-/g, "_");
};
const isLocale = (value) => LOCALES.includes(value);
export {
  isLocale,
  replaceHyphensWithUnderscores,
  replaceUnderscoresWithHyphens
};
//# sourceMappingURL=utils.js.map